import React, { useRef } from 'react'

const Hero = () => {


  return (
    <div className='h-fit lg:h-[100vh] w-full px-6 md:px-12 lg:px-0 pt-[25vh] md:pt-[15vh] lg:pt-12 pb-[5vh] lg:pb-6 bg-white-purple-bg bg-cover bg-center flex flex-col gap-6 items-center justify-end ' >
        <iframe className='h-[30vh] md:h-[40vh] lg:h-[70vh] w-full lg:w-[65vw] rounded-lg' src="https://www.youtube.com/embed/GSD-NQ4O3c8?si=92a3IVyw1j6X-PvW" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        <div className='flex flex-row-reverse w-full justify-between text-4xl text-[#231f20]' >
          {/* <h3>Incredible things happen when you get Together with Bluedoor</h3> */}
          {/* <h3>hen you get Together with Bluedoor</h3> */}
        </div>   
    </div>
  )
}

export default Hero
